import { FTLRepository } from '../repositories/FTL.repository'
import { FTLCreateAdditionalServicePayloadT } from '../types/additional_services.types'
import {
    ChangeActNumberPayloadT,
    FTLGetCapacityResponseT,
    FTLGetCarTypesResponseT,
    FTLGetCommentsResponse,
    FTLGetDangerClassResponseT,
    FTLGetTransportTypesResponseT,
    FTLPrintTTNResponseT,
    UpdateFtlIntracityOrderPayload,
    UpdateFTLOrderPayloadI,
} from '../types/ftl.types'

const ftlRepository = new FTLRepository()

export class FTLService {
    async getCapacity(): Promise<FTLGetCapacityResponseT> {
        const response = await ftlRepository.getCapacity()
        return response.data
    }

    async getComments(stateId: number): Promise<FTLGetCommentsResponse> {
        const response = await ftlRepository.getComments(stateId)
        return response.data
    }

    async getTransportTypes(): Promise<FTLGetTransportTypesResponseT> {
        const response = await ftlRepository.getTransportTypes()
        return response.data
    }

    async getDangerClass(): Promise<FTLGetDangerClassResponseT> {
        const response = await ftlRepository.getDangerClass()
        return response.data
    }

    async printTTN(id: number): Promise<FTLPrintTTNResponseT> {
        const response = await ftlRepository.printTTN(id)
        return response.data
    }

    async printRoute(order_id: number): Promise<any> {
        const response = await ftlRepository.printRoute(order_id)
        return response.data
    }

    async updateOrder(order_id: number, payload: UpdateFTLOrderPayloadI): Promise<void> {
        const response = await ftlRepository.updateOrder(order_id, payload)
        return response.data
    }

    async updateOrderLikeIntracity(order_id: number, payload: UpdateFtlIntracityOrderPayload): Promise<void> {
        const response = await ftlRepository.updateOrderLikeIntracity(order_id, payload)
        return response.data
    }

    async updateOrderIntracity(
        order_id: number,
        payload: UpdateFtlIntracityOrderPayload
    ): Promise<void> {
        const response = await ftlRepository.updateOrderIntracity(order_id, payload)
        return response.data
    }

    async changeActNumber(payload: ChangeActNumberPayloadT): Promise<void> {
        const response = await ftlRepository.changeActNumber(payload)
        return response.data
    }

    async createAdditionalService(payload: FTLCreateAdditionalServicePayloadT): Promise<void> {
        const response = await ftlRepository.createAdditionalService(payload)
        return response.data
    }

    async getCarTypes(): Promise<FTLGetCarTypesResponseT> {
        const response = await ftlRepository.getCarTypes()
        return response.data
    }

    async uploadInvoiceDocument(form_data: FormData): Promise<void> {
        const response = await ftlRepository.uploadInvoiceDocument(form_data)
        return response.data
    }

    async deleteOrderAdditionalService(additional_service_id: number): Promise<void> {
        const response = await ftlRepository.deleteOrderAdditionalService(additional_service_id)
        return response.data
    }

    async throwInBilling(id: number): Promise<void> {
        const response = await ftlRepository.throwInBilling(id)
        return response.data
    }

    async printFtlOrderInvoices(order_id: number): Promise<any> {
        const response = await ftlRepository.printFtlOrderInvoices(order_id)
        return response.data
    }

    async printFtlOrderStockDeliveryNoteInvoice(
        order_id: number,
        stock_delivery_note_index: number
    ): Promise<any> {
        const response = await ftlRepository.printFtlOrderStockDeliveryNoteInvoice(
            order_id,
            stock_delivery_note_index
        )
        return response.data
    }

    async uploadFtlStockScan(ftl_stock_id: number, form_data: FormData): Promise<void> {
        const response = await ftlRepository.uploadFtlStockScan(ftl_stock_id, form_data)
        return response.data
    }

    async uploadFtlOrderScan(ftl_order_id: number, form_data: FormData): Promise<void> {
        const response = await ftlRepository.uploadFtlOrderScan(ftl_order_id, form_data)
        return response.data
    }

    async createLogisticBid(id: number, form_data: FormData): Promise<void> {
        const response = await ftlRepository.createLogisticBid(id, form_data)
        return response.data
    }
}
